import { Row } from "./Row";
interface IProsp {
  isShow: boolean;
  onToggle: () => void;
}

export const NoticeToCaliforniaResidents = ({ onToggle, isShow }: IProsp) => {
  return (
    <Row
      title="Notice to California Residents"
      onToggle={onToggle}
      isShow={isShow}
    >
      <div>
        <div className="font-bold pb-2">
          a. Disclosures Under the California Consumer Privacy Act (CCPA)
        </div>
        <div className="p-2">
          <div className="font-bold pb-2">
            i. Categories of Personal Information and Uses
          </div>
          The table below summarizes the categories of personal information we
          collect from California residents, and the business and commercial
          purposes for which the categories of personal information will be used
          and may have been used in the last 12 months. We may have collected
          any or all of these categories of personal information in the last 12
          months. As noted above, we do not sell personal information in the
          ordinary course of business. In addition, we have not made any sales
          of personal information in the past 12 months.
          <table className="border border-solid border-gray-400 dark:border-gray-600 w-full">
            <thead>
              <th className="py-2 px-3" colSpan={2}>
                Categories of Personal Information Collected
              </th>
              <th className="py-2 px-3 border-l border-solid border-gray-400 dark:border-gray-600">
                Purposes of Use
              </th>
            </thead>
            <tbody>
              <tr>
                <td
                  colSpan={2}
                  className="border border-solid border-gray-400 dark:border-gray-600 py-2 px-3"
                >
                  “Identifiers” such as a real name, alias, postal address,
                  telephone number, email address, and account name. See
                  Sections 4(a), 4(c)(i), and 4(d) above regarding the
                  collection of Identifiers.
                </td>
                <td className="border border-solid border-gray-400 dark:border-gray-600 py-2 px-3">
                  See all purposes in Sections 5(a), 5(c)(i), and 5(d) above.
                </td>
              </tr>
              <tr>
                <td
                  colSpan={2}
                  className="border border-solid border-gray-400 dark:border-gray-600 py-2 px-3"
                >
                  Internet Protocol (IP) address. See Sections 4(b)(i) and
                  4(c)(ii) above.
                </td>
                <td className="border border-solid border-gray-400 dark:border-gray-600 py-2 px-3">
                  See Sections 5(b) and 5(c)(ii) above.
                </td>
              </tr>
              <tr>
                <td
                  rowSpan={3}
                  className="border border-solid border-gray-400 dark:border-gray-600 py-2 px-3"
                >
                  Information (other than Identifiers already described above)
                  that identifies, relates to, describes, or is capable of being
                  associated with, a particular individual, including, but not
                  limited to:
                </td>
                <td className="border border-solid border-gray-400 dark:border-gray-600 py-2 px-3">
                  Signature
                </td>
                <td className="border border-solid border-gray-400 dark:border-gray-600 py-2 px-3">
                  We may collect signatures on correspondence sent to us by
                  postal mail or, in the case of electronic signatures, by email
                  or other electronic communications.
                </td>
              </tr>
              <tr>
                <td className="border border-solid border-gray-400 dark:border-gray-600 py-2 px-3">
                  Physical characteristics. Our smart health and fitness devices
                  may collect physical characteristics such as weight, blood
                  pressure, and fitness metrics.
                </td>
                <td className="border border-solid border-gray-400 dark:border-gray-600 py-2 px-3">
                  Our applications may receive physical characteristic
                  information from Medcursor-compatible smart health and fitness
                  devices. These devices and the associated applications use
                  physical characteristics to help you understand your health
                  and fitness status.
                </td>
              </tr>
              <tr>
                <td className="border border-solid border-gray-400 dark:border-gray-600 py-2 px-3">
                  Bank account number, credit card number, debit card number, or
                  any other financial information. See Section 4(c) above for
                  more details.
                </td>
                <td className="border border-solid border-gray-400 dark:border-gray-600 py-2 px-3">
                  See Section 5(c)(i) above.
                </td>
              </tr>

              <tr>
                <td
                  colSpan={2}
                  className="border border-solid border-gray-400 dark:border-gray-600 py-2 px-3"
                >
                  Commercial information, including records of products and
                  services purchased, obtained, or considered, or other
                  purchasing or consuming histories or tendencies. See Section
                  4(c)(i) above for more details.
                </td>
                <td className="border border-solid border-gray-400 dark:border-gray-600 py-2 px-3">
                  See the purposes in Section 5(c)(i) above.
                </td>
              </tr>
              <tr>
                <td
                  colSpan={2}
                  className="border border-solid border-gray-400 dark:border-gray-600 py-2 px-3"
                >
                  Electronic information. Any of the information we collect may
                  be in electronic form. See Section 4 for more details.
                </td>
                <td className="border border-solid border-gray-400 dark:border-gray-600 py-2 px-3">
                  See the purposes in Section 5 above.
                </td>
              </tr>
              <tr>
                <td
                  colSpan={2}
                  className="border border-solid border-gray-400 dark:border-gray-600 py-2 px-3"
                >
                  Inferences drawn from other personal information described in
                  this section reflecting users’ preferences collected in the
                  form of notes in our user database.
                </td>
                <td className="border border-solid border-gray-400 dark:border-gray-600 py-2 px-3">
                  Our sales and marketing team may collect notes about user
                  preferences based on purchasing and download history and
                  website usage data to assist in understanding our users’ needs
                  and wishes in connection with marketing and selling our and
                  our product partners’ products and services.
                </td>
              </tr>
              <tr>
                <td
                  colSpan={2}
                  className="border border-solid border-gray-400 dark:border-gray-600 py-2 px-3"
                >
                  Context-specific personal information not specifically covered
                  within the categories above. Any kinds of personal information
                  could be submitted to us in communications to us or social
                  media posts. See Sections 4(a) and 4(d) above.
                </td>
                <td className="border border-solid border-gray-400 dark:border-gray-600 py-2 px-3">
                  See Section 5(a) and 5(d) above.{" "}
                </td>
              </tr>
            </tbody>
          </table>
          {/* <div className="rows h-[995]">
              <div className="width60 flex">
                <div
                  className="center flex-1 border-r border-solid border-[#333]"
                >
                  Information (other than Identifiers already described above)
                  that identifies, relates to, describes, or is capable of being
                  associated with, a particular individual, including, but not
                  limited to:
                </div>
                <div style="flex:1;display:flex;flex-direction: column;">
                  <div
                    className="center"
                    style="flex:2;border-bottom:2rpx solid #333;"
                  >
                    Signature
                  </div>
                  <div
                    className="center"
                    style="flex:3;border-bottom:2rpx solid #333;"
                  >
                    Physical characteristics. Our smart health and fitness
                    devices may collect physical characteristics such as weight,
                    blood pressure, and fitness metrics.
                  </div>
                  <div className="center" style="flex:2;">
                    Bank account number, credit card number, debit card number,
                    or any other financial information. See Section 4(c) above
                    for more details.
                  </div>
                </div>
              </div>
              <div
                className="cell width40"
                style="display:flex;flex-direction: column;padding: 0;"
              >
                <div
                  className="center"
                  style="flex:2;border-bottom:2rpx solid #333;width:100%;"
                >
                  We may collect signatures on correspondence sent to us by
                  postal mail or, in the case of electronic signatures, by email
                  or other electronic communications.
                </div>
                <div
                  className="center"
                  style="flex:3;border-bottom:2rpx solid #333;"
                >
                  Our applications may receive physical characteristic
                  information from Medcursor-compatible smart health and fitness
                  devices. These devices and the associated applications use
                  physical characteristics to help you understand your health
                  and fitness status.
                </div>
                <div className="center" style="flex:2;">
                  See Section 5(c)(i) above.
                </div>
              </div>
            </div> */}
          <div className="mt-4">
            If we collect your personal information for purposes covered in this
            policy and seek to use the personal information for a different
            purpose not covered by this policy, we will notify you and, where
            required, seek additional consent to use personal information for
            the other purpose.
          </div>
          <div className="font-bold mt-4 pb-2">
            ii. Individual Rights Under the CCPA
          </div>
          <div className="font-bold pb-2">
            1. Right of Access and Data Portability
          </div>
          Upon request, we will tell a California resident the categories and
          specific pieces of personal information we have collected about that
          resident in the previous 12 months. In addition, upon request, we will
          disclose to a California resident:
          <ul className="list-disc pl-8 mt-2 text-gray666 dark:text-white60">
            <li>
              The categories of personal information we have collected about
              that California resident.
            </li>
            <li>
              The categories of sources from which the personal information is
              collected.
            </li>
            <li>
              The business or commercial purpose for collecting that California
              resident’s personal information.
            </li>
            <li>
              The categories of third parties with whom we share personal
              information.
            </li>
            <li>
              The specific pieces of personal information we have collected
              about that California resident (subject to limits under applicable
              law)
            </li>
          </ul>
          <div className="mt-4">
            The identity of any person making such a request must be verified as
            a condition of providing the requested information. See Section 9(b)
            (Identity Verification).
          </div>
          <div className="font-bold mt-4 pb-2">2. Right of Deletion</div>
          You have the right to request that we delete any of your personal
          information that we collected from you and retained by us, subject to
          certain conditions and exceptions under the law. For instance, we have
          the right to retain personal information needed to:
          <ul className="list-disc pl-8 mt-2 text-gray666 dark:text-white60">
            <li>
              Complete the transaction for which the personal information was
              collected, provide a good or service requested by the California
              resident, or reasonably anticipated within the context of our
              ongoing business relationship with the California resident, or
              otherwise perform a contract between our business and the
              California resident.
            </li>
            <li>
              Detect security incidents, protect against malicious, deceptive,
              fraudulent, or illegal activity; or prosecute those responsible
              for that activity.
            </li>
            <li>
              Conduct solely internal uses that are reasonably aligned with the
              expectations of the California resident based on the California
              resident’s relationship with us.
            </li>
            <li>Comply with a legal obligation.</li>
            <li>
              Use the personal information internally, in a lawful manner that
              is compatible with the context in which the California resident
              provided it.
            </li>
          </ul>
          <div className="font-bold mt-4 pb-2">
            3. How to Exercise Rights of Access, Portability, or Deletion
          </div>
          If you wish to contact us about any of your rights as set out in this
          Section 7(a)(ii), all such requests should be submitted to us using
          the contact information in Section 11. We will use the procedures in
          Section 9(b) (Identity Verification) to verify the identity of the
          California resident or authorized agent.
          <div className="font-bold mt-4 pb-2">
            4. Policy Against Discrimination
          </div>
          Medcursor will not discriminate against individual California residents
          for exercising any of their rights under the CCPA, including by:
          <ul className="list-disc pl-8 mt-2 text-gray666 dark:text-white60">
            <li>Denying goods or services to the California resident;</li>
            <li>
              Charging different prices or rates for goods or services,
              including through the use of discounts or other benefits or
              imposing penalties;
            </li>
            <li>
              Providing a different level or quality of goods or services; or
            </li>
            <li>
              Suggesting that the California resident will receive a different
              price or rate for goods or services or a different level or
              quality of goods or services.
            </li>
          </ul>
        </div>
        <div className="font-bold mt-4 pb-2">
          b. Notice to California Residents Regarding "Do Not Track" Settings
        </div>
        Under California law, online service providers must say in their privacy
        policies how they respond to “do not track” settings that users can set
        in their browser software. Currently, there is no standard governing
        what, if anything, a website operator should do when receiving a "do not
        track" signal. Therefore, Medcursor does not currently take action in
        response to a “do not track" browser setting. Medcursor will update this
        policy in response to developments regarding an industry standard
        concerning do not track settings.
      </div>
    </Row>
  );
};
